<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  targetTitle: { type: String, default: 'imóvel' },
  options: { type: Array, default: () => [] },
  status: { type: String, default: '' },
  justification: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
  disableConfirm: { type: Boolean, default: false },
  selectClass: { type: String, default: '' },
  textareaClass: { type: String, default: '' },
});

const emit = defineEmits([
  'confirm',
  'close',
  'update:status',
  'update:justification',
]);

const dialogRef = ref(null);

defineExpose({
  open: () => dialogRef.value?.open(),
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Registrar negativa"
    confirm-button-label="Salvar status"
    cancel-button-label="Cancelar"
    :is-loading="isLoading"
    :disable-confirm-button="disableConfirm"
    @confirm="emit('confirm')"
    @close="emit('close')"
  >
    <div class="space-y-4 text-[13px] text-lais-text">
      <div class="rounded-lais border border-red-100 bg-red-50 px-4 py-3">
        <div class="flex items-start gap-3">
          <span
            class="grid size-9 shrink-0 place-items-center rounded-full bg-white text-red-700 ring-1 ring-red-100"
          >
            <span class="i-lucide-ban size-4" aria-hidden="true" />
          </span>
          <div class="min-w-0">
            <p class="text-[11px] font-bold uppercase text-red-700">
              Não publicar agora
            </p>
            <p class="mt-1 font-semibold text-lais-text">
              {{ targetTitle }}
            </p>
            <p class="mt-0.5 text-[12px] text-lais-text-muted">
              O motivo ficará salvo no histórico deste pendente.
            </p>
          </div>
        </div>
      </div>

      <label class="grid gap-1">
        <span class="text-[11px] font-semibold text-lais-text-muted">
          Status
        </span>
        <select
          :value="status"
          :class="selectClass"
          @change="emit('update:status', $event.target.value)"
        >
          <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </label>

      <label class="grid gap-1">
        <span class="text-[11px] font-semibold text-lais-text-muted">
          Justificativa
        </span>
        <textarea
          :value="justification"
          :class="textareaClass"
          placeholder="Explique o motivo para não publicar/atualizar este imóvel."
          @input="emit('update:justification', $event.target.value)"
        />
      </label>
    </div>
  </Dialog>
</template>
